import { Injectable } from "@angular/core";

import { HttpClient } from "@angular/common/http";
import { environment as env } from "../../../../../../environments/environment.prod";
import { AbstractService } from "app/services/abstract.service";

const apiUrl = env.API_MATERIAL_URL;
const moduleName = "material";

@Injectable({
  providedIn: "root",
})
export class ImageService extends AbstractService<any,any,any> {

    URL_S3 = env.URL_AMAZON_S3

    constructor(
        http: HttpClient,
    ) {
        super(apiUrl, moduleName, http);
    }

    public getPathImageMaterial(image) {
        let url_amazon = this.URL_S3
        return url_amazon + '/products/original/' + image
    }
}
